export const calendar = {
  title: "Calendrier",
  subtitle: "Gérez les réservations de vos hébergements",
  createBooking: "Créer une réservation",
  propertyLabel: "Hébergement",
  searchPlaceholder: "Rechercher un hébergement",
  filterByProperty: "Filtrer les hébergements",
  clearFilters: "Effacer les filtres",
  loadingMore: "Chargement d’autres dates…",

  payment: {
    "pending":  "Paiement en attente",
    "paid":     "Payé",
    "rejected": "Paiement refusé",
    "refunded": "Remboursé",
    "partial":  "Paiement partiel"
  },

  tooltips: {
    noChannels: "Connecté à aucun canal",
    connectedTo: "Connecté à : {channels}",
    manual: "WA Checkin (manuel)",
    other: "Autre canal",
    configPrices: "Configurer les prix",
  },

  errors: {
    loadCalendar: "Erreur lors du chargement des données du calendrier",
    updateViewAfterCancel: "Erreur lors de la mise à jour de l'affichage après annulation",
    closeDates: "Erreur lors de la fermeture des dates",
    deleteClosedDates: "Erreur lors de la suppression des dates fermées",
    updateClosedDates: "Erreur lors de la mise à jour des dates fermées",
  },

  filters: {
    showPrices: "Afficher les prix",
    today: "Aujourd'hui",
    multi: "Multiple",
    monthly: "Mensuel",
    prevMonthAria: "Mois précédent",
    nextMonthAria: "Mois suivant",
  },

  actions: {
    title: "Sélectionnez une action",
    question: "Que souhaitez-vous faire avec les dates sélectionnées ?",
    createBooking: "Créer une réservation",
    blockDates: "Fermer la date",
    editNightPrice: "Modifier le prix par nuit",
    editMinStay: "Séjour minimum",
    editMinStayHint: "Définir le nombre minimum de nuits par date",
  },
  minStayModal: {
    description:
      "Définissez le séjour minimum pour la plage de dates sélectionnée. Cela n'affectera pas les prix existants.",
    success: "Séjour minimum mis à jour avec succès",
    hint: "Nombre minimum de nuits que le client doit réserver.",
    errors: {
      minOne: "Le séjour minimum doit être d'au moins 1 nuit.",
    },
  },

  fields: {
    startDate: "Date de début",
    endDate: "Date de fin",
  },

  buttons: {
    delete: "Supprimer",
    cancel: "Annuler",
    save: "Enregistrer",
    close: "Fermer",
    saveChanges: "Enregistrer les modifications",
    closeDates: "Fermer les dates",
  },

  closeModal: {
    headerCreate: "FERMER LES DATES",
    headerEdit: "MODIFIER LES DATES FERMÉES",
  },

  priceModal: {
    description:
      "Il s'agit d'une modification manuelle du tarif que vous sélectionnez. Tout ce que vous modifiez ici n'affectera que cet hébergement et cette plage de dates.",
    periodLabel: "Période de dates",
    startPlaceholder: "Date de début",
    endPlaceholder: "Date de fin",
    pricePerNight: "Prix par nuit",
    minStay: "Séjour minimum",
    minNightsPlaceholder: "Nuits minimum",
    pricePlaceholder: "Prix pour la plage sélectionnée",
    success: "Prix mis à jour avec succès",
    errors: {
      invalidRange: "Vous devez sélectionner une plage de dates valide",
      startAfterEnd: "La date de début ne peut pas être postérieure à la date de fin",
      minStay:
        "Le séjour minimum est de {min} nuits, mais la plage sélectionnée compte {nights} nuits",
      missingSelection: "Aucun hébergement ni plage de dates n'a été sélectionné",
      request: "Erreur de requête : {msg}",
      update: "Erreur lors de la mise à jour des prix : {msg}",
    },
  },

  details: {
    header: "Détails de la réservation",
    title: "Réservation",
    createdOn: "Créée le {date}",
    checkIn: "Check-in",
    checkOut: "Check-out",
    arrow: "→",
    statusLabel: "Statut",
    status: {
      booked: "Réservé",
      blocked: "Bloqué",
    },
    night_one: "Nuit",
    night_other: "Nuits",
    actions: {
      view: "Voir la réservation",
      changeRoom: "Changer de chambre",
      cancel: "Annuler la réservation",
    },
  },
};

export default calendar;